export default __webpack_public_path__ + "static/media/thumbnail.796f89ed.png";